/**
 * @file pre-complete-profile.component.ts
 */
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TokenService } from '@core/services';
import { AppCenterAnalytics, AppInsightsService } from '@shared/services';
import { CompleteProfileService } from './complete-profile.service';
import { AppConstants } from '@root/app/app.constants';

@Component({
  standalone: true,
  selector: 'app-pre-complete-profile',
  templateUrl: './pre-complete-profile.component.html',
  styleUrls: ['./pre-complete-profile.component.scss'],
})
export class PreCompleteProfileComponent {
  constructor(
    private readonly active: ActivatedRoute,
    private readonly router: Router,
    private readonly tokenService: TokenService,
    private readonly completeProfileService: CompleteProfileService,
    private readonly appInsightsService: AppInsightsService
  ) {
    this.active.fragment.subscribe((fragment) => {
      this.appInsightsService.trackPageViewWithoutClientId(
        `${AppCenterAnalytics.SSO_INITIATE_MEMBER_LOGIN}`
      );

      if (fragment) {
        const urlSearchParams = new URLSearchParams(fragment);
        this.completeProfileService.ssoToken = urlSearchParams.get(AppConstants.SSO_TOKEN) || '';
        this.completeProfileService.user = {
          email: urlSearchParams.get('email') || '',
          dateOfBirth: urlSearchParams.get('dateOfBirth') || '',
          firstName: urlSearchParams.get('firstName') || '',
          lastName: urlSearchParams.get('lastName') || '',
          contactNumber: urlSearchParams.get('contactNumber') || '',
          cardId: urlSearchParams.get('cardId') || '',
          clientId: urlSearchParams.get('clientId') || '',
          personCode: urlSearchParams.get('personCode') || '',
          userName: urlSearchParams.get('username') || ''
        };

        this.appInsightsService.trackPageViewWithoutClientId(
          `${AppCenterAnalytics.SSO_PRE_COMPLETE_PROFILE_DATA_LOADED}`,
          this.getProperties()
        );

        if (!this.completeProfileService.ssoToken) {
          this.appInsightsService.trackPageViewWithoutClientId(
            `${AppCenterAnalytics.SSO_PRE_COMPLETE_PROFILE_NO_SSO_TOKEN}`,
            this.getProperties()
          );

          this.router.navigate(['/main']);
        } else {
          this.tokenService.setSSOToken(this.completeProfileService.ssoToken);
          this.tokenService.setProviderType();
          this.appInsightsService.trackPageViewWithoutClientId(
            `${AppCenterAnalytics.PRE_COMPLETE_PROFILE_PAGE_VIEWED}`,
            this.getProperties()
          );
          this.router.navigate(['complete-profile']);
        }
      }
    });
  }

  public getProperties(): Record<string, any> {
    const properties: Record<string, any> = {
      clientID: this.completeProfileService.user.clientId,
      CardID: this.completeProfileService.user.cardId,
      Name: `${this.completeProfileService.user.firstName} ${this.completeProfileService.user.lastName}`,
      Email: this.completeProfileService.user.email,
    };
    return properties;
  }

  getDate(): string {
    const dateToday = new Date();
    return `${dateToday.getFullYear()}/${dateToday.getMonth() + 1}/${dateToday.getDate()}`;
  }
}
